const STORAGE_KEY = 'crm_invoice_templates';

export const listInvoiceTemplates = () => {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
  } catch {
    return [];
  }
};

export const saveInvoiceTemplate = (template) => {
  const list = listInvoiceTemplates();
  const entry = {
    id: template.id || Date.now(),
    name: template.name,
    description: template.description || '',
    payload: template.payload,
    updatedAt: new Date().toISOString(),
  };
  const idx = list.findIndex((t) => t.id === entry.id);
  if (idx >= 0) list[idx] = entry;
  else list.push(entry);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  return entry;
};

export const deleteInvoiceTemplate = (id) => {
  const list = listInvoiceTemplates().filter((t) => t.id !== id);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
};

export const getInvoiceTemplate = (id) =>
  listInvoiceTemplates().find((t) => t.id === id) || null;
